<template>
  <div class="inline">
    <el-form-item :class="{'is-error':error}" class="date-time-item">
      <el-input-number :precision="column.precision||null" v-model="min" :style="{width:column.inputWidth||'90px'}"
                       placeholder="最低价"></el-input-number>
      <span class="between-style">~</span>
      <el-input-number :precision="column.precision||null" v-model="max" :style="{width:column.inputWidth||'90px'}"
                       placeholder="最高价"></el-input-number>
      <div v-show="error" class="el-form-item__error">区间小值必须小于区间大值</div>
    </el-form-item>
  </div>
</template>
<script>
  export default {
    props: ['column'],
    data() {
      return {
        // min:'',
        // max:'',
        min: undefined,
        max: undefined,
        error: false
      }
    },
    watch: {
      min(newValue) {
        this.numberCompare();
      },
      max(newValue) {
        this.numberCompare();
      }
    },
    methods: {
      clearData() {
        // this.min = '';
        // this.max = '';
        this.min = undefined;
        this.max = undefined;
        this.error = false;
      },
      setValue(min, max) {
        this.min = min;
        this.max = max;
      },
      numberCompare() {
        if (this.min && this.max && this.min > this.max) {
          this.error = true;
        } else {
          this.error = false;
        }
      },
      // numberCompare(){
      //   if(this.min != null && this.min != undefined && this.max != null && this.max != undefined && this.min > this.max){
      //     this.error = true;
      //   }else{
      //     this.error = false;
      //   }
      // },
      getFormData() {
        if (this.error) {
          return false;
        } else {
          return (this.min !== undefined ? '' + this.min : '') + (this.max !== undefined ? (',' + this.max) : '');
        }
      }
    }
  }
</script>
<style scoped>
  >>> .el-input__inner {
    padding: 0;
  }

  .between-style {
    display: inline-block;
    width: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/controls/numberRange.vue